import { Link } from 'react-router-dom'
import styled from 'styled-components'

const Container = styled.div`
  flex: 1 0 auto;
  text-align: center;
  margin-top: 7rem;
`

const FourOhFour = () => (
  <Container style={{ textAlign: 'center' }}>
    <h1>404</h1>
    <h2>page not found</h2>
    <p>
      <Link to="/claimuploadcenter">Home</Link>
    </p>
  </Container>
)

export { FourOhFour }
